import { AxiosError } from "axios";
import fleetlogicAPI from "helpers/fleetlogicAPI";
import Uri from "jsuri";
import { StatusCodes } from "http-status-codes";
import store from "../reduxstore/reduxStore";
import { logout } from "../actions";
import { AUTH_URL } from "../constants/AppConstants";
import browserHistory from "./GoogleGa";

fleetlogicAPI.interceptors.response.use(
  res => res,
  (error: AxiosError) => {
    try {
      const { response } = error;
      const uri = new Uri(response.config.url.toString());

      function isSameHost() {
        const host = uri.host();
        return host === "" || host === window.location.hostname;
      }

      function isAuthUrl() {
        return uri.path().includes(AUTH_URL);
      }

      function shouldAllowUnauthorizedUser() {
        return /^\/contract_signature_requested/.test(window.location.pathname);
      }
      if (response.status === StatusCodes.NOT_ACCEPTABLE &&
        isSameHost() &&
        !isAuthUrl()
      ) {
        if(!shouldAllowUnauthorizedUser()){
          store.dispatch(logout());
          browsernavigate("/");
        }
        caches.keys().then((keyList) => {
          return Promise.all(
            keyList.map((key) => {
              return caches.delete(key);
            })
          );
        });
        // @ts-ignore
        location.reload(true)
        return
      }
      if (
        response.status === StatusCodes.UNAUTHORIZED &&
        isSameHost() &&
        !isAuthUrl() &&
        !shouldAllowUnauthorizedUser()
      ) {
        store.dispatch(logout());
        browsernavigate("/");
      }
    } finally {
      return Promise.reject(error);
    }
  }
);
